import { AnimatePresence } from "framer-motion";
import { useAuth } from "@/vocab/AuthContext";
import TrialEndedModal from "./TrialEndedModal";

/**
 * SubscriptionGate
 *
 * Wraps all authenticated routes. When the user has no active access
 * (expired trial or no subscription), shows TrialEndedModal on top of
 * the page. Admins and users with active access pass straight through.
 */
export default function SubscriptionGate({ children }) {
  const { user } = useAuth();

  // Not loaded yet — render nothing until auth resolves
  if (!user) return null;

  // Admins and paying/trialing users get the full app
  if (user.role === "admin" || user.has_access) return children;

  // Trial ended / subscription lapsed — show the upgrade modal.
  // canDismiss=false: user must subscribe or sign out (handled inside modal).
  return (
    <>
      {children}
      <AnimatePresence>
        <TrialEndedModal canDismiss={false} />
      </AnimatePresence>
    </>
  );
}